import {forwardRef, InputHTMLAttributes, ReactNode, useCallback} from 'react';

import ClearIcon from '~assets/images/icons/ui/close.svg';

import {ClearBtn, FieldContainer, Input} from './styles';

type TextFieldProps = Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'value' | 'onChange'
> & {
    icon?: ReactNode;
    withClearBtn?: boolean;
    value?: string | number | null;
    onChange?: (value: any) => void;
    className?: string;
    valueAsNumber?: boolean;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
    function TextField(
        {
            value,
            onChange,
            icon,
            withClearBtn,
            className,
            valueAsNumber,
            ...inputProps
        },
        ref,
    ) {
        const handleChange = useCallback(
            (v: string) => {
                if (onChange) {
                    if (inputProps.type === 'number' || valueAsNumber) {
                        const num = Number(v);

                        if (Number.isNaN(num)) {
                            onChange(null);
                        } else {
                            onChange(num);
                        }
                    } else {
                        onChange(v);
                    }
                }
            },
            [onChange],
        );

        return (
            <FieldContainer
                withIcon={Boolean(icon)}
                className={className}
                onClick={(ev) =>
                    // @ts-ignore
                    ev.target?.tagName === 'DIV' &&
                    // @ts-ignore
                    (ev.target as HTMLDivElement).querySelector('input').focus()
                }
                disabled={inputProps.disabled}
            >
                {icon}
                <Input
                    {...(onChange && {
                        value:
                            value === null || value === undefined
                                ? ''
                                : value.toString(),
                        onChange: (ev) => handleChange(ev.target.value),
                    })}
                    ref={ref}
                    {...inputProps}
                />
                {withClearBtn && (
                    <ClearBtn onClick={() => handleChange('')}>
                        <ClearIcon />
                    </ClearBtn>
                )}
            </FieldContainer>
        );
    },
);
